'use strict'
define [], () ->
  () ->
    (str) ->
      if str and str.length >= 25
        return str[0..25] + "..."
      str



// WEBPACK FOOTER //
// ./filters/concat.coffee